import { t, tryT, type MessageKey } from '@reos/i18n';

/**
 * Lidsky popisek MCP nastroje pro Dnesek (ADM1 bod 4) - makler nema videt
 * technicky identifikator jako `party.merge_parties`. Vzor je stejny jako
 * `lib/broker-text.ts captionOrPreparing()`: zkus kuratorsky preklad pro
 * konkretni nastroj (`webAdmin.dnesek.toolLabel.<domain>.<action>`), jinak
 * slozeny fallback z popisku oblasti (`toolDomain`) a rozepsane akce -
 * NIKDY surovy tecka.podtrzitko kod.
 */

const cs = { locale: 'cs' } as const;

function prettyAction(action: string): string {
  const words = action.split('_').filter((w) => w !== '');
  const text = words.join(' ');
  return text.length === 0 ? action : text.charAt(0).toUpperCase() + text.slice(1);
}

export function humanToolLabel(tool: string): string {
  const curated = tryT(`webAdmin.dnesek.toolLabel.${tool}` as MessageKey, cs);
  if (curated !== undefined) return curated;

  const dotIndex = tool.indexOf('.');
  const domain = dotIndex === -1 ? tool : tool.slice(0, dotIndex);
  const action = dotIndex === -1 ? '' : tool.slice(dotIndex + 1);
  const domainLabel = tryT(`webAdmin.dnesek.toolDomain.${domain}` as MessageKey, cs) ?? domain;
  return t('webAdmin.dnesek.toolFallback', { ...cs, values: { action: prettyAction(action), domain: domainLabel } });
}
